module.exports = __webpack_public_path__ + "static/media/play-circle-regular.29d906ab.svg";